import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta(
    "页面未找到 - 51动漫",
    "抱歉，你访问的页面不存在。可以返回 51动漫首页，或浏览动漫作品与最新资讯。"
  );

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-32 min-h-[60vh] flex flex-col items-center justify-center text-center">
      <div className="font-heading font-extrabold text-7xl md:text-9xl text-primary-500 leading-none mb-4">
        404
      </div>
      <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
        页面走丢了
      </h1>
      <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-md">
        抱歉，你访问的页面不存在或已被移动。不妨回到首页，继续探索精彩的动漫世界。
      </p>
      <div className="flex items-center gap-3 flex-wrap justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/anime"
          className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-movie-line"></i>
          浏览动漫
        </Link>
      </div>
    </div>
  );
}